export const formLabelStyles = {
  components: {
    FormLabel: {
      baseStyle: {
        fontSize: 'xs',
        fontWeight: 'semibold',
        mb: 1,
        color: 'gray.700',
      },
    },
  },
};
